var map = {
	"./de.json": "6ce2",
	"./el.json": "f184",
	"./en-gb.json": "32cd",
	"./en-us.json": "e3b5",
	"./en-za.json": "0b93",
	"./en.json": "edd4",
	"./es-us.json": "9477",
	"./es.json": "a306",
	"./fr-be.json": "01d4",
	"./fr-lu.json": "f63b",
	"./fr.json": "f693",
	"./gsw-berne.json": "58ad",
	"./hu.json": "4e73",
	"./it.json": "0825",
	"./nl-be.json": "71f5",
	"./nl.json": "a625",
	"./nn.json": "962f",
	"./pl.json": "89b2",
	"./pt-pt.json": "ccb6",
	"./uk.json": "62ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "231a";